<template>
  <a-card type="inner" size="small">
    <a-skeleton :loading="preload" active>
      <a-row>
        <a-col :span="12">
          <a-form-model :model="formData" :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
            <a-form-model-item label="Product Group" prop="product">
              <a-select
                show-search
                placeholder="Select Product Group"
                style="width: 100%"
                :filterOption="false"
                :defaultValue="formData.product_group"
                @search="fetchGroups"
                @change="handleChange"
                @focus="fetchGroupsOnFocus"
                :notFoundContent="fetching ? undefined : null "
                :loading="fetching">
                <a-spin v-if="fetching" slot="notFoundContent" size="small"/>
                <a-select-option :key="'all'" :value="''">ALL</a-select-option>
                <a-select-option v-for="d in data" :key="d.id" :value="d.id">{{ d.name }}</a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Source Account" prop="source_account">
              <a-input placeholder="Source Account" v-model="formData.source_account" :maxLength="16">
                <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Biller Fee Account" prop="biller_fee_account">
              <a-input placeholder="Fee Biller Account" v-model="formData.biller_fee_account" :maxLength="16">
                <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Biller Amount Account" prop="biller_amount_account">
              <a-input placeholder="Biller Amount Account" v-model="formData.biller_amount_account" :maxLength="16">
                <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Profit Fee Account" prop="profit_fee_account">
              <a-input placeholder="Profit Fee Account" v-model="formData.profit_fee_account" :maxLength="16">
                <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Transaction Account" prop="transaction_account">
              <a-input placeholder="Transaction Account" v-model="formData.transaction_account" :maxLength="16">
                <a-icon slot="prefix" type="bank" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item :label-col="{span: 8}" :wrapper-col="{ span: 12 }" label="Treshold Sponsor Fee" prop="sponsor_fee_threshold">
              <a-input placeholder="Treshold Sponsor Fee" v-model="formData.sponsor_fee_threshold" :maxLength="4">
                <a-icon slot="prefix" type="dollar" style="color: rgba(0,0,0,0.25)"/>
              </a-input>
            </a-form-model-item>
            <a-form-model-item>
              <a-row type="flex" justify="center" align="top">
                <a-col>
                  <a-popconfirm :title="'Are you sure you want to submit data?'" @confirm="handleSubmit">
                    <a-button
                        type="primary"
                        html-type="submit"
                        :loading="loading"
                        :disabled="loading"
                        >Submit</a-button>
                  </a-popconfirm>
                </a-col>
              </a-row>
            </a-form-model-item>
          </a-form-model>
        </a-col>
      </a-row>
    </a-skeleton>
  </a-card>
</template>

<script>
export default {
  name: "create-biller-account",
  props: {
    path: {
      type: String,
      required: true
    },
    path_show: {
      type: String,
      default: ""
    },
    history: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: false,
      formData: {
        product_group: null
      },
      preload: false,
      data: [],
      fetching: false,
      item: {}
    }
  },
  created() {
    if(this.editing) {
      this.fetchGroups()
      this.getItem()
    }
  },
  computed: {
    editing() {
      return this.path_show != ""
    }
  },
  methods: {
    fetchGroups(value) {
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.product-group'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    fetchGroupsOnFocus(value) {
      if(this.editing)
        return
      this.data = []
      this.fetching = true
      this.$http.get(this.routeUri('hyperion.product-group'), {
        params: {q: value}
      })
        .then((response) => this.data = response.data.data)
        .finally(() => this.fetching = false)
    },
    getItem() {
      this.preload = true
      this.$http.get(this.path_show)
        .then((response) => {
          this.item = response.data
        })
        .catch((error) => this.handleXhrError(error))
        .finally(() => this.preload = false)
    },
    handleChange(value) {
      this.formData.product_group = value
    },
    handleSubmit(e) {
        this.loading = true;

        let promise;

        if(this.editing){
          promise = this.$http.put(
              this.path,
              this.formData
          );
        } else {
          promise = this.$http.post(
              this.path,
              this.formData
          );
        }

        promise
          .then(response =>
              this.handleSuccessResponse(response.data)
          )
          .catch(err => this.handleXhrError(err))
          .finally(() => (this.loading = false));
    },
    handleSuccessResponse(data) {
      this.$notification.success({
        message: "Success",
        description: "You will be redirected in a few moment."
      })

      setTimeout(() => window.location.href = this.history, 3000)
    },
  },
  watch: {
    item(value) {
      this.formData.product_group = value.product_group_id
      this.formData.source_account = value.source_account
      this.formData.biller_fee_account = value.biller_fee_account
      this.formData.biller_amount_account = value.biller_amount_account
      this.formData.profit_fee_account = value.profit_fee_account
      this.formData.transaction_account = value.transaction_account
      this.formData.sponsor_fee_threshold = value.sponsor_fee_threshold
    }
  }
}
</script>
